import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getVirginiaBeachStructuredData() {
  const url = "https://restorehair.com/locations/virginia/virginia-beach/";
  const description =
    "Find out about your hair transplant options in Virginia Beach with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("virginia-beach", url, description),
    locationPageCrumbs(url, "Virginia Beach"),
  ];
}
